import { render, staticRenderFns } from "./YearwiseEfficiencyEdit.vue?vue&type=template&id=5d8d4cfe"
import script from "./YearwiseEfficiencyEdit.vue?vue&type=script&lang=js"
export * from "./YearwiseEfficiencyEdit.vue?vue&type=script&lang=js"
import style0 from "./YearwiseEfficiencyEdit.vue?vue&type=style&index=0&id=5d8d4cfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports